import { all, call, fork, put, select, spawn, take } from 'redux-saga/effects';
import { FAILURE, SUCCESS } from '../../modules/bets/actions';
import betsRequest from '../../modules/bets/saga';
import {
  beginOfTomorrowGMT,
  dateAddDays,
  dateDiffDays,
  dateDiffSeconds
} from '../../utils/dates/date';
import {
  LOAD_NEXT_SLIP,
  LOAD_PREVIOUS_WEEK,
  setBets,
  setViewIsLoading,
  VIEW_ENTER
} from './actions';
import { BETS_CHUNK_DAYS, BETS_INITIAL_CHUNK_OVERLAP } from './constants';
import { getNextSlip, getSinceDate } from './selectors';

export function* loadSettledBets(incrementalByDate = false, incrementalBySlip = false) {
  let currentSince;
  let overlap;
  let nextSlip;
  if (incrementalByDate) {
    currentSince = yield select(getSinceDate);
    overlap = 0;
  } else {
    currentSince = beginOfTomorrowGMT(new Date());
    overlap = BETS_INITIAL_CHUNK_OVERLAP;
  }
  const dateFrom = dateDiffDays(currentSince, BETS_CHUNK_DAYS + overlap);
  const dateTo = dateDiffSeconds(currentSince, 1);
  const showActiveSlips = !incrementalByDate;
  if (incrementalBySlip) {
    nextSlip = yield select(getNextSlip);
  } else {
    nextSlip = null;
  }
  yield fork(betsRequest, dateFrom, dateTo, showActiveSlips, nextSlip);

  const { type, results } = yield take([SUCCESS, FAILURE]);
  if (type === SUCCESS) {
    yield put(
      setBets(results, incrementalByDate, incrementalBySlip, dateAddDays(dateFrom, overlap))
    );
  }
}

export function* watchViewEnter() {
  while (yield take(VIEW_ENTER)) {
    yield put(setViewIsLoading(true));
    yield call(loadSettledBets, false, false);
    yield put(setViewIsLoading(false));
  }
}

export function* watchLoadPreviousWeek() {
  while (yield take(LOAD_PREVIOUS_WEEK)) {
    yield call(loadSettledBets, true, false);
  }
}

export function* watchLoadNextSlip() {
  while (yield take(LOAD_NEXT_SLIP)) {
    yield call(loadSettledBets, false, true);
  }
}

export default function* settledBetsRoot() {
  yield all([
    spawn(watchViewEnter),
    spawn(watchLoadPreviousWeek),
    spawn(watchLoadNextSlip)
  ]);
}
